import { LanguageType } from '@op/types/common';
import { DBO_FEEDS } from '@op/utils/format';

const VideoTitleMap = {
  origin: 'video_title',
  en: 'video_title_en',
  zh: 'video_title_zh',
};

const VideoContentMap = {
  origin: 'content_text',
  en: 'content_text_en',
  zh: 'content_text_zh',
};

const VideoCategoryMap = {
  origin: 'category',
  en: 'category_en',
  zh: 'category_zh',
};

const ChannelNameMap = {
  origin: 'channel_name',
  en: 'channel_name_en',
  zh: 'channel_name_zh',
};

const VideoTagMap = {
  origin: 'video_tag',
  en: 'video_tag_en',
  zh: 'video_tag_zh',
};

const VideoDescMap = {
  origin: 'video_desc',
  en: 'video_desc_en',
  zh: 'video_desc_zh',
};

export function getVideoTitle(language: LanguageType, item: any) {
  return DBO_FEEDS.origin(VideoTitleMap, language, item);
}

export function getVideoContent(language: LanguageType, item: any) {
  return DBO_FEEDS.origin(VideoContentMap, language, item);
}

export function getCategory(language: LanguageType, item: any) {
  return DBO_FEEDS.origin(VideoCategoryMap, language, item);
}

export function getTextByGlobal(
  languageMap: { origin: any; en: any; zh: any },
  isEn: boolean,
  item: any,
) {
  const language = isEn ? 'en' : 'zh';
  const key = languageMap[language];
  return item[key] || item?.[languageMap?.origin] || '';
}

export function getCategoryByGlobal(isEn: boolean, item: any) {
  return getTextByGlobal(VideoCategoryMap, isEn, item);
}

export function getChannelName(language: LanguageType, item: any) {
  return DBO_FEEDS.origin(ChannelNameMap, language, item);
}

export function getChannelNameByGlobal(isEn: boolean, item: any) {
  return getTextByGlobal(ChannelNameMap, isEn, item);
}

export function getVideoTag(language: LanguageType, item: any) {
  return DBO_FEEDS.origin(VideoTagMap, language, item);
}

export function getVideoTagByGlobal(isEn: boolean, item: any) {
  return getTextByGlobal(VideoTagMap, isEn, item);
}

export function getVideoDesc(language: LanguageType, item: any) {
  return DBO_FEEDS.origin(VideoDescMap, language, item);
}

const MemeTitleMap = {
  origin: 'title',
  en: 'title',
  zh: 'title_zh',
};

export function getMemeTitle(language: LanguageType, item: any) {
  return DBO_FEEDS.origin(MemeTitleMap, language, item);
}

const MemeContentMap = {
  origin: 'content',
  en: 'content',
  zh: 'content_zh',
};

export function getMemeContent(language: LanguageType, item: any) {
  return DBO_FEEDS.origin(MemeContentMap, language, item);
}

const MemeWhyHotMap = {
  origin: 'why_hot',
  en: 'why_hot',
  zh: 'why_hot_zh',
};

export function getMemeWhyHot(language: LanguageType, item: any) {
  return DBO_FEEDS.origin(MemeWhyHotMap, language, item);
}

const MemeRegionCodeMap = {
  origin: 'region_code',
  en: 'region_code_en',
  zh: 'region_code_zh',
};

export function getMemeRegionCode(language: LanguageType, item: any) {
  return DBO_FEEDS.origin(MemeRegionCodeMap, language, item);
}

const MemeTypeMap = {
  origin: 'meme_type',
  en: 'meme_type',
  zh: 'meme_type_zh',
};

export function getMemeType(language: LanguageType, item: any) {
  return DBO_FEEDS.origin(MemeTypeMap, language, item);
}

const MemeElementsMap = {
  origin: 'meme_elements',
  en: 'meme_elements',
  zh: 'meme_elements_zh',
};

export function getMemeElements(language: LanguageType, item: any) {
  return DBO_FEEDS.origin(MemeElementsMap, language, item);
}
